import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Textarea } from "../ui/textarea";
import { toast } from "sonner";

export default function FieldEditor({
  label,
  placeholder,
  value,
  onChange,
  testIdBase,
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value || "");
      setCopied(true);
      toast.success(`${label} copied`);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      toast.error("Couldn't copy", { description: e.message });
    }
  };

  return (
    <div
      data-testid={`field-${testIdBase}`}
      className="bg-white rounded-2xl border border-slate-200/80 shadow-soft p-5"
    >
      <div className="flex items-center justify-between mb-2.5">
        <label className="font-outfit text-sm font-semibold text-[#0F172A] tracking-tight">
          {label}
        </label>
        <button
          data-testid={`field-${testIdBase}-copy`}
          onClick={handleCopy}
          disabled={!value}
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full font-figtree text-xs font-medium transition-all ${
            copied
              ? "bg-[#D1FAE5] text-[#065F46]"
              : "text-[#64748B] hover:text-[#059669] hover:bg-[#F0FDF4] disabled:opacity-40 disabled:hover:bg-transparent disabled:hover:text-[#64748B]"
          }`}
        >
          {copied ? (
            <>
              <Check className="w-3.5 h-3.5" />
              Copied
            </>
          ) : (
            <>
              <Copy className="w-3.5 h-3.5" />
              Copy
            </>
          )}
        </button>
      </div>

      <Textarea
        data-testid={`field-${testIdBase}-textarea`}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={4}
        className="font-figtree text-sm border-slate-200 focus-visible:ring-[#10B981] rounded-xl resize-y min-h-[88px]"
      />
    </div>
  );
}
